<template>
  <v-layout
    row
    wrap
  >
    <v-flex
      :class="hideButtons ? 'md4' : 'md3'"
      xs12
    >
      <v-text-field
        v-model="name"
        :label="$t('Name')"
        :disabled="disabled"
        outline
        class="mx-1"
      />
    </v-flex>
    <v-flex
      :class="hideButtons ? 'md6' : 'md5'"
      xs12
      class="mt-2"
    >
      <v-layout
        row
        wrap>
        <v-flex
          v-if="extra.options && extra.options.length"
          xs10
        >
          <v-chip
            v-for="option in extra.options || []"
            :key="option.key"
            :disabled="disabled"
            @click="editOption(option)"
          >
            {{ option.value }}
            <v-icon
              :disabled="disabled"
            >
              expand_more
            </v-icon>
            <v-divider
              vertical
              class="mx-1"
            />
            <v-icon
              :disabled="disabled"
              small
              @click.stop="removeOption(option)"
            >
              close
            </v-icon>
          </v-chip>
        </v-flex>
        <v-flex
          v-else
          xs10
        >
          <span class="grey--text d-block mt-2 mx-2">{{ $t('No options added') }}</span>
        </v-flex>
        <v-flex xs2>
          <v-btn
            v-if="(!isOtherLanguage || possibleOptions.length) && !disabled"
            icon
            right
            color="success"
            @click="addOption"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
        <v-flex
          xs6
          class="pa-0 ma-0"
        >
          <v-select
            v-if="selecting"
            :items="possibleOptions"
            class="pa-0 ma-0"
            item-text="value"
            item-value="key"
            return-object
            @change="selectionFromExisting"
          />
        </v-flex>
        <product-extra-option
          v-if="selectedOption"
          v-model="selectedOption.value"
          :original="originalOption"
          @canceled="selectedOption = null; addingOption = false"
          @confirmed="createOrUpdateOption()"
        />
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      md2
    >
      <v-text-field
        v-model.number="limit"
        :label="$t('Limit')"
        :disabled="disabled || isOtherLanguage"
        outline
        class="mx-1"
      />
    </v-flex>
    <v-flex
      v-if="!hideButtons"
      xs12
      sm2
    >
      <v-btn
        :disabled="disabled || disableCreation()"
        icon
        color="success"
        @click="create"
      >
        <v-icon>check</v-icon>
      </v-btn>
      <v-btn
        :disabled="disabled"
        icon
        color="error"
        @click="$emit('removed', extra.key)"
      >
        <v-icon v-if="!isNew">delete</v-icon>
        <v-icon v-else>close</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import randomstr from 'randomstring'
import ProductExtraOption from '@/modules/Products/components/ProductExtraOption'

export default {
  name: 'ProductExtra',
  components: { ProductExtraOption },
  props: {
    value: {
      required: false,
      type: Object,
      default: () => {
        return {
          key: null,
          name: '',
          options: [],
          limit: null
        }
      }
    },
    hideButtons: {
      required: false,
      type: Boolean,
      default: false
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    },
    isNew: {
      required: false,
      type: Boolean,
      default: false
    },
    language: {
      required: false,
      type: Object,
      default: null
    },
    model: {
      required: false,
      type: Object,
      default: null
    }
  },

  data () {
    return {
      extra: {
        key: '',
        name: '',
        options: [],
        limit: null
      },
      selectedOption: null,
      isCreated: false,
      addingOption: false,
      selecting: false
    }
  },

  computed: {
    name: {
      get () {
        return this.extra.name
      },
      set (value) {
        this.extra.name = value
        this.$emit('change', this.extra)
      }
    },
    limit: {
      get () {
        return this.extra.limit
      },
      set (value) {
        this.extra.limit = value
        this.$emit('change', this.extra)
      }
    },
    isOtherLanguage () {
      return this.language && !this.language.default && !this.isNew
    },
    possibleOptions () {
      const options = this.model.extras.filter(ext => this.extra.key === ext.key)[0].options
      if (!options || !options.length) {
        return []
      }

      return options.filter(opt => {
        return !this.extra.options.some(o => o.key === opt.key)
      })
    },
    originalOption () {
      if (!this.isOtherLanguage || !this.selectedOption) {
        return null
      }

      const options = this.model.extras.filter(ext => this.extra.key === ext.key)[0].options

      let find = options.find(opt => this.selectedOption.key === opt.key)
      console.log(find)
      return find.value || null
    }
  },

  created () {
    this.extra.key = this.value.key || randomstr.generate(16)
    this.extra.name = this.value.name
    this.extra.options = this.value.options || []
    this.extra.limit = this.value.limit
  },

  methods: {
    disableField () {
      return this.value.key === null && !this.isNew
    },

    disableCreation () {
      if (!this.isNew) {
        return this.isCreated || this.value.key !== null
      }

      return !(!!this.name && this.value.options.length)
    },

    create () {
      this.$emit('created', this.extra)
      this.isCreated = true
    },

    addOption () {
      if (this.isOtherLanguage) {
        this.selecting = true
        return
      }

      this.selectedOption = {
        value: null,
        key: randomstr.generate(16)
      }
    },

    selectionFromExisting (option) {
      this.selectedOption = {
        value: option.value,
        key: option.key
      }

      this.selecting = false
    },

    editOption (option) {
      if (this.disabled) {
        return
      }
      this.selectedOption = { ...option }
    },

    removeOption (option) {
      if (this.disabled) {
        return
      }

      this.extra.options = this.extra.options.filter(opt => {
        return opt.key !== option.key
      })

      this.$emit('change', this.extra)
      this.$emit('removedSubField', this.extra.key, option.key)

      this.selectedOption = null
    },

    createOrUpdateOption () {
      const has = this.extra.options.find(opt => opt.key === this.selectedOption.key)
      if (has) {
        this.extra.options = this.extra.options.map(opt => {
          if (opt.key === this.selectedOption.key) {
            opt.value = this.selectedOption.value
          }

          return { ...opt }
        })
      } else {
        this.extra.options.push({ ...this.selectedOption })
      }

      this.$emit('change', this.extra)

      this.selectedOption = null
      this.addingOption = false
    }
  }
}
</script>
